import { createFileRoute } from '@tanstack/react-router'

import { CreateSettlementPage } from '@/pages/admin/settlements/create-settlement-page'

export const Route = createFileRoute('/_private/admin/settlements_/new')({
  component: CreateSettlementPage,
})
